import React from "react";
import { MDBIcon } from "mdbreact";
import Button from "../Button/Button";
import "./Modal.css";

export default function Modal({
  show,
  onClose,
  type = "error",
  title,
  message,
  buttonText = "Mengerti",
}) {
  if (!show) return null;

  const icons = {
    error: "exclamation-circle",
    warning: "exclamation-triangle",
    success: "check-circle",
    info: "info-circle",
  };

  const titles = {
    error: "Terjadi Kesalahan",
    warning: "Perhatian",
    success: "Berhasil",
    info: "Informasi",
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-card"
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="modal-close"
          aria-label="Tutup"
          onClick={onClose}
        >
          <MDBIcon icon="times" />
        </button>

        <div className={`modal-icon modal-icon-${type}`}>
          <MDBIcon icon={icons[type]} />
        </div>

        <h5 className="modal-title">{title || titles[type]}</h5>

        <p className="modal-message">{message}</p>

        <div className="modal-actions">
          <Button text={buttonText} onClick={onClose} />
        </div>
      </div>
    </div>
  );
}
